export default [{
    path: "/breeze",
    component: () => import("@/components/Administrator/AdminLoginView.vue"),
    meta: {
        title: "管理员主页"
    }
}, {
    path: "/adminPanel",
    component: () => import("@/components/Administrator/AdministratorPage.vue"),
    meta: {
        title: "管理员主页"
    },
    children: [{
        path: "monitorElements",
        components: {
            adminPanelRouterView: () => import("@/components/Administrator/v1/Admin_MonitorElementManageView.vue")
        }
    }, {
        path: "addNewAccount",
        components: {
            adminPanelRouterView: () => import("@/components/Administrator/v1/Admin_AddNewAccount.vue")
        }
    }, {
        path: "portProtocols",
        components: {
            adminPanelRouterView: () => import("@/components/Administrator/v1/Admin_PortProtocols.vue")
        }
    }, {
        path: "allUsersManagement",
        components: {
            adminPanelRouterView: () => import("@/components/Administrator/v1/Admin_AllUsersManagement.vue")
        }
    }, {
        path: "dtuManagement",
        components: {
            adminPanelRouterView: () => import("@/components/Administrator/v1/Admin_DTU_Management.vue")
        }
    }, {
        path: "dtuServerManagement",
        components: {
            adminPanelRouterView: () => import("@/components/Administrator/v1/Admin_DTUServerManagement.vue")
        }
    }, {
        path: "pluginManagement",
        components: {
            adminPanelRouterView: () => import("@/components/Administrator/v1/Admin_PluginManagement")
        }
    }]
}]